<template>
 <div class="root">
        <header>Community Guidelines</header>
        <p>
            Haba is a place for your creativity and expression. It’s also a global community of people looking for a
            fun, welcoming experience.
        </p>
        <p>
            The Community Guidelines, which we update from time to time, are an important code of conduct for a safe and
            friendly environment. Violation of the guidelines may result in your account and/or content being removed.
            In addition, users must also follow their local laws. We reserve the right to monitor and report content to
            authorities, as permitted by applicable law.
        </p>
        <p>
            Our <router-link to="/terms">Terms of Service</router-link> and guidelines exist to foster trust, respect,
            and a positive environment for everyone in this community. We trust all users to respect the community and
            keep Haba fun and welcoming for everyone.
            Haba is simply NOT the place to post, share, or promote any of the following, including:
        </p>
        <p>
            Harmful or dangerous content
        </p>
        <p>
            When you use Haba you are joining a global community. Don’t post or share content that could harm other
            users or encourage them to harm themselves – whether through physical, emotional, financial, or legal harm.
        </p>
        <li>
            Terrorist organizations and any other criminal organizations are strictly prohibited from using Haba. DO
            NOT use Haba to promote and support these organizations or individuals.
        </li>
        <li>
            DO NOT post, share, or send any content that depicts dangerous acts, self-injury, or suicide, nor provide
            any content that encourages other people to engage in such activities.
        </li>
        <li>
            DO NOT post, share, or send any content that depicts, promotes, encourages, or provides instruction for
            eating disorders.
        </li>
        <li>
            DO NOT intimidate or threaten other people, including threats of physical harm against a specific
            individual.
        </li>
        <li>
            DO NOT use Haba to sell or encourage the use of weapons, bombs, drugs, or any other regulated goods
            prohibited by local laws.
        </li>
        <li>
            DO NOT use Haba to encourage or promote online gambling or other financial schemes.
        </li>
        <li>
            DO NOT post, share, or send any content that involves illegal activities.
        </li>
        <p>
            Graphic or shocking content
        </p>
        <p>
            Haba is not the place for graphic, violent, shocking, or sensational content. If you wouldn’t show this
            content to your parents or children, please don’t post it here.
        </p>
        <li>
            DO NOT post, share, or send any violent, graphic, shocking, or sensational content, nor provide any content
            that incites others to commit acts of violence.
        </li>
        <p>
            Discrimination or hate speech
        </p>
        <p>
            Haba is an inclusive community. It is not OK to attack or incite violence against other users.
        </p>
        <li>
            DO NOT post, share, or send any content that incites hatred against a group of people based on their race,
            ethnicity, religion, nationality, culture, disability, sexual orientation, gender, gender identity, age, or
            any other discrimination.
        </li>
        <li>
            DO NOT post, share, or send contents that may trigger hostility, including trolling or provocative remarks.
        </li>
        <p>
            Nudity or sexual activity
        </p>
        <p>
            Haba community is not the place for sexually explicit content or content intended for sexual
            gratification. If it isn’t something suitable to be done or shown in public view, don’t post it.
        </p>
        <li>
            Haba strictly prohibits any content that contains, promotes, or encourages sexual assault, sexual abuse,
            sexual exploitation, or sexual violence. DO NOT post any such content.
        </li>
        <li>
            DO NOT post, share, or send explicit content, sexual content, or nudity.
        </li>
        <li>
            DO NOT provide content related to prostitution, solicitation, or any other types of sex trade.
        </li>
        <p>
            Child safety infringement
        </p>
        <p>
            Haba takes child safety with the utmost seriousness. If we become aware of content that sexually
            exploits, targets, or endangers children, we may report cases to law enforcement and cooperate with them, as
            appropriate.
        </p>
        <li>
            Haba strictly prohibits any sexually explicit content featuring minors or content that sexually exploits
            minors. DO NOT post any such content.
        </li>
        <li>
            Haba may remove or limit access to photos containing nudity, sexually suggestive acts, or
            unintentionally provocative content involving minors, as such photos could be used by others in
            unanticipated ways.
        </li>
        <li>
            DO NOT post, share, or send any content about online dating with minors, compensated dating, invasion of a
            minor’s privacy, or other content that endangers minors’ physical and mental health.
        </li>
        <li>
            DO NOT use public posts or private messages to harass underage users.
        </li>
        <li>
            DO NOT use the app if you are under 13, or the minimum age for your country or region if designated
            differently in the <router-link to="/privacy">Privacy Policy</router-link>and  <router-link to="/terms">Terms of Services.</router-link>
        </li>
       
       
        <p>
            Harassment or cyberbullying
        </p>
        <p>
            e work hard to promote a positive environment and an abuse-free experience for our users. Please keep your
            interactions civil and treat all users with respect.
        </p>
        <li>
            DO NOT use public posts and/or private messages to harass other people.
        </li>
        <li>
            DO NOT disclose others’ personally identifiable information, such as address, phone number, email address,
            ID number, and credit card number.
        </li>
        <li>
            DO NOT deliberately degrade, humiliate, defame, or bully other people, nor encourage other users to do so.
        </li>
        <p>
            Impersonation, spam, scams, or other misleading content
        </p>
        <p>
            Our community values high-quality, engaging content. Content that is spammy, fake, fraudulent, or misleading
            is prohibited and will be removed.
        </p>
        <li>
            DO NOT impersonate another person or organization by creating fake identities, confuse others into
            believing that your relationship with another person or organization is something it is not, or post
            misleading content to make money.
        </li>
        <li>
            DO NOT create artificial traffic by any means, such as trading comments, hiring others or being hired to
            write comments, sharing repetitive content, sending chain letters, and using deceptive information to
            encourage views, likes or comments.
        </li>
        <li>
            DO NOT post any content, or conduct any activity, that harms members of our community. This includes
            defrauding users, phishing schemes, and deceptive practices.
        </li>
        <p>
            Intellectual property
        </p>
        <p>
            Haba is a place for creativity and expression that is unique and original.
        </p>
        <li>
            DO NOT post, share, or send any content that violates someone else’s copyrights, trademarks, or other intellectual property rights.
        </li>
        <p>
            Other malicious activity
        </p>
        <p>
            In addition to the content and behavior outlined above, our policies prohibit activity that undermines the Haba service or damage Haba's legitimate interests.
        </p>
        <li>
            DO NOT interfere with Haba’s daily operation, hack its website or associated networks, or bypass its measures to restrict users’ access.
        </li>
        <li>
            DO NOT distribute files that contain viruses, trojans, worms, logic bombs, or other material that is malicious or technologically harmful.
        </li>
        <li>
            DO NOT modify, adapt, translate, reverse engineer, disassemble, decompile, or create any derivative products based on Haba, including any files, tables or documentation, nor attempt to regenerate any source code, algorithms, methods, or techniques embodied in Haba.
        </li>
        <li>
            DO NOT use automated scripts to collect information from Haba.
        </li>
        <li>
            DO NOT pretend to be Haba officials to trick users.
        </li>
        <li>
            DO NOT use bug to implement behaviors that benefit, damage the Platform environment, or adversely affect other users
        </li>
        <li>
            DO NOT conduct account transactions with others without authorization;
        </li>
        <li>
            DO NOT try to make illegal profits and harm the interests of the platform by any other way to circumvent the rules of the platform.
        </li>
        <p>
            Any activity by any member of the Haba community that harms, defrauds, or misleads other users or harms our community will be considered a violation of our Community Guidelines and may result in your content and/or account being removed.
        </p>
        <p>
            Thank you for being wonderful community members and doing your part to maintain a safe and enjoyable space for all users. If you see content that you believe violates any of the Community Guidelines, please report it in Haba APPso we can review and take appropriate action. If you have further concerns, please contact <span style="color: blue;">report@habagogo.com</span>
        </p>
        


    </div>

</template>  

<script>
export default {
  name: "privacy",
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.root{
    text-align: left;
    margin: 10px;
}
header{
    
    padding: 10px;
    text-align: center;
    font-size: 40px;
    font-weight: bold;
    margin-bottom: 10px;
    font-weight: 900;
}
div {
    font-size: 25px;
    font-weight: 900;
}
b{
    font-size: 20px;
    font-weight: 900;
}

p{
    font-size: 16px;
    font-weight: 500;
}
table {
    border-collapse: collapse;
}

th, td {
    border: 1px solid black;
    padding: 8px;
    text-align: left;
}
td ,li{
    font-size: 16px;
}
a{
    color: blue;
}</style>
